import {
    ElementRef,
    Injectable,
    Injector,
    NgModuleRef,
    ViewContainerRef,
    createNgModule,
} from "@angular/core";

import type {
    QuickBuyModalModule,
    QuickBuyModalService,
    QuickBuyProductInfos,
} from "@hermes/fragments/quick-buy-modal";

@Injectable()
export class QuickBuyModalManagerService {
    private quickBuyModalServiceInstance?: QuickBuyModalService;
    private moduleRef?: NgModuleRef<QuickBuyModalModule>;

    constructor(private injector: Injector) {}

    public async openQuickBuyModal(
        quickBuyProductInfos: QuickBuyProductInfos,
        elementReference: ElementRef,
        viewContainerReference: ViewContainerRef,
    ): Promise<void> {
        if (!this.moduleRef || !this.quickBuyModalServiceInstance) {
            const quickBuyModalModule = await import(
                "@hermes/fragments/quick-buy-modal"
            );
            const module = createNgModule(
                quickBuyModalModule.QuickBuyModalModule,
                this.injector,
            );
            this.moduleRef = module;
            this.quickBuyModalServiceInstance = module.injector.get(
                quickBuyModalModule.QuickBuyModalService,
            );
        }

        this.quickBuyModalServiceInstance.openModal(
            quickBuyProductInfos,
            elementReference.nativeElement,
            viewContainerReference,
            this.moduleRef,
        );
    }

    public closeQuickBuyModal() {
        if (this.moduleRef && this.quickBuyModalServiceInstance) {
            this.quickBuyModalServiceInstance.closeModal();
        }
    }
}
